import type { ReactNode } from "react";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Stack } from "@volca/ui/components/ui/stack";

/**
 * A CSV the API would not open as a spreadsheet (too large): why, over its
 * rows as Volca read them.
 */
export const RefusedWorkbook = ({
  reason,
  children,
}: {
  reason: string;
  /** The rows as read (the Preview table). */
  children: ReactNode;
}) => (
  <Stack gap={3} align="stretch" className="min-w-0 lg:min-h-0 lg:flex-1">
    <Alert color="information" role="status">
      <AlertDescription>
        {reason} These are its rows as Volca read them.
      </AlertDescription>
    </Alert>
    {children}
  </Stack>
);
